module.exports = __webpack_public_path__ + "img/couples-016.c62d0a41.jpg";